import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w100" }
const _hoisted_3 = { class: "fl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt20 fs13" }, "◯◯から招待された公開ページ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "fw600 fs16 fl mt10" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"12px","right":"7px","background":"#69d54f"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!

  return (_ctx.astags)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FlashNotice),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.astags, (astag, astagindex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${astagindex}${astag.selected}${astag.id}${astag.type}${astag.name}${_ctx.systemUpdatedAt}`,
              class: "mb10 posRe centered mr10 pad10 w100 rad10 borderGrey"
            }, [
              _createVNode(_component_CalendarIcon, {
                astag: astag,
                width: 120,
                iconWidth: 50,
                totalHeight: 120,
                onClickAstag: _ctx.selectAstag,
                canDelete: _ctx.canDelete && !astag.is_shared ? true : false,
                iconStyles: {
                        marginLeft: `18%`,
                        paddingTop: `17px`,
                    },
                onDeleteAstag: _ctx.deleteAstag,
                onChangeDefault: _ctx.changeDefault,
                onClickCopy: _ctx.clickCopy,
                onCreateVotedRoom: _ctx.createVotedRoom,
                showSharedInfo: true,
                hideName: true,
                hideBorder: true
              }, null, 8, ["astag", "onClickAstag", "canDelete", "onDeleteAstag", "onChangeDefault", "onClickCopy", "onCreateVotedRoom"]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(astag.name), 1),
                _createElementVNode("label", {
                  class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround hoverSkyblueBg`),
                  style: {"width":"110px","padding":"4px 10px","margin-right":"10px"},
                  onClick: ($event: any) => (_ctx.selectAstag(astag))
                }, " 編集 ", 8, _hoisted_7),
                _hoisted_8
              ]),
              (astag.selected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                      width: "17",
                      height: "17",
                      style: {"margin-top":"-2px"}
                    }, null, 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_11
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}